export type OrganizationPayload = {
	readonly id: number;
	readonly name: string;
	readonly siret: string | null;
	readonly headOfficeAddress: string | null;
	readonly documentFooterMentions: string | null;
};

export type OrganizationsFetchedPayload = OrganizationPayload[];

export type OrganizationsFetchedAction = {
	type: 'ORGANIZATIONS_FETCHED';
	payload: OrganizationsFetchedPayload;
	accountId: number;
};

export default (payload: OrganizationsFetchedPayload, accountId: number): OrganizationsFetchedAction => ({
	type: 'ORGANIZATIONS_FETCHED',
	payload,
	accountId,
});
